

function navigationSlide() {
  if (document.querySelector("#toggle")) {
    let toggleMenu = document.querySelector("#toggle");
    let htmlEl = document.querySelector("html");

    toggleMenu.addEventListener("click", (event) => {
      // toggle the menu button and navigation open/close state
      let _this = event.target;
      _this.classList.toggle("active");
      document.querySelector(".navigation").classList.toggle("open");
      htmlEl.classList.toggle("overflow-hidden");
    });

    // Close/remove the navigation whenever any anchor is clicked while the nav is open.
    // Using event delegation so we don't have to bind handlers to every <a>.
    document.addEventListener("click", (event) => {
      const anchor = event.target.closest && event.target.closest("a");
      const navEl = document.querySelector(".navigation");

      // If the click wasn't on an <a> element, ignore.
      if (!anchor) return;

      // We'll only act if navigation exists and is currently open.
      if (navEl && navEl.classList.contains("open")) {
        // Remove the active/open classes so the nav closes.
        if (toggleMenu && toggleMenu.classList.contains("active")) {
          toggleMenu.classList.remove("active");
        }

        navEl.classList.remove("open");
        htmlEl.classList.remove("overflow-hidden");
      }
    });
  }
}

export default navigationSlide;
